import { render, staticRenderFns } from "./FluxoDiario.vue?vue&type=template&id=24009738&"
import script from "./FluxoDiario.vue?vue&type=script&lang=js&"
export * from "./FluxoDiario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports